export const GET_X_CONTACTS = "GET_X_CONTACTS";
export const GET_X_CONTACTS_SUCCESS = "GET_X_CONTACTS_SUCCESS";
export const GET_X_CONTACTS_FAIL = "GET_X_CONTACTS_FAIL";

